/* =====================================================================
   JF — Klaviyo "Cart Updated" custom event
   Pushes the FULL cart to Klaviyo on every cart change (debounced), so
   abandonment emails can show the real cart instead of the last-added item.

   - Fires on cart STATE (wraps /cart/add|change|update|clear + ajaxProduct:added)
   - Debounced: rapid adds = one event
   - Fires for everyone (like Klaviyo's native events); Klaviyo stitches anonymous
     activity onto the profile on identify and only emails the emailable
   - Excludes the Einwegpfand deposit (ProductID + "fee rule" type)
   - De-duplicated via a cart hash in localStorage
   ===================================================================== */
(function () {
  'use strict';

  var CONFIG = {
    eventName: 'Cart Updated',
    depositProductId: '15735186325877',
    debounceMs: 1200,
    storageKey: 'jf_cart_updated_hash',
    currency: 'EUR'
  };

  var timer = null;

  /* ---------- deposit / fee-rule filter ---------- */
  function isDeposit(it) {
    var pid = String(it.product_id || '');
    var type = (it.product_type || '').toLowerCase();
    var handle = (it.handle || '').toLowerCase();
    var title = (it.product_title || it.title || '').toLowerCase();
    return pid === CONFIG.depositProductId ||
      type === 'fee rule' || type === 'pfand' ||
      handle.indexOf('fee-rule') > -1 || handle.indexOf('pfand') > -1 ||
      title.indexOf('pfand') > -1 || title.indexOf('einwegpfand') > -1;
  }

  function httpsUrl(u) {
    if (!u) return '';
    if (u.indexOf('//') === 0) return 'https:' + u;
    return u;
  }

  /* ---------- push to Klaviyo (prefer _learnq, proven on this store) ---------- */
  function klTrack(name, props) {
    if (window._learnq && typeof window._learnq.push === 'function') {
      window._learnq.push(['track', name, props]);
    } else if (window.klaviyo && typeof window.klaviyo.push === 'function') {
      window.klaviyo.push(['track', name, props]);
    } else {
      window._learnq = window._learnq || [];
      window._learnq.push(['track', name, props]);
    }
  }

  /* ---------- build the payload from /cart.js ---------- */
  function buildPayload(cart) {
    var origin = window.location.origin;
    var real = (cart.items || []).filter(function (it) { return !isDeposit(it); });

    var items = real.map(function (it) {
      var vt = it.variant_title;
      if (vt === 'Default Title') vt = '';
      return {
        ProductID: it.product_id,
        ProductName: it.product_title || it.title,
        VariantID: it.variant_id || it.id,
        VariantName: vt || '',
        Quantity: it.quantity,
        LinePrice: (it.final_line_price != null ? it.final_line_price : it.line_price) / 100,
        ImageURL: httpsUrl(it.image || (it.featured_image && it.featured_image.url)),
        ProductURL: origin + (it.url || '')
      };
    });

    var total = real.reduce(function (s, it) {
      return s + (it.final_line_price != null ? it.final_line_price : it.line_price);
    }, 0) / 100;

    var count = real.reduce(function (s, it) { return s + (it.quantity || 0); }, 0);

    // restore permalink → lands on /cart → drawer opens with the cart rebuilt
    var permalink = real.length
      ? origin + '/cart/' + real.map(function (it) { return (it.variant_id || it.id) + ':' + it.quantity; }).join(',')
      : origin + '/cart';

    return {
      real: real,
      payload: {
        '$value': total,
        Currency: CONFIG.currency,
        ItemCount: count,
        CartTotal: total,
        CartURL: permalink,
        CheckoutURL: origin + '/checkout',
        ItemNames: items.map(function (i) { return i.ProductName; }),
        Items: items
      }
    };
  }

  function hashOf(built) {
    var basis = built.payload.CartTotal + '|' + built.real.map(function (it) {
      return (it.variant_id || it.id) + 'x' + it.quantity;
    }).join(',');
    return basis;
  }

  /* ---------- main sync ---------- */
  function syncCart() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var built = buildPayload(cart);
        if (!built.real.length) return;                 // empty (or deposit-only) cart → nothing to abandon

        var hash = hashOf(built);
        var last = null;
        try { last = localStorage.getItem(CONFIG.storageKey); } catch (e) {}
        if (hash === last) return;                        // unchanged since last fire — skip redundant event

        // Fire for everyone, exactly like Klaviyo's native events: Klaviyo stitches
        // anonymous activity onto the profile once identified, and only emails the emailable.
        klTrack(CONFIG.eventName, built.payload);
        try { localStorage.setItem(CONFIG.storageKey, hash); } catch (e) {}
      })
      .catch(function () { /* silent */ });
  }

  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(syncCart, CONFIG.debounceMs);
  }

  /* ---------- detect cart mutations ---------- */
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?/i;

  // fetch (JF add-to-cart + any fetch-based cart ops)
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function () {
      var out = _fetch.apply(this, arguments);
      try {
        var arg = arguments[0];
        var url = typeof arg === 'string' ? arg : (arg && arg.url) || '';
        if (CART_MUTATION.test(url)) out.then(function () { schedule(); }).catch(function () {});
      } catch (e) {}
      return out;
    };
  }

  // XMLHttpRequest (theme.js / jQuery cart ops)
  if (window.XMLHttpRequest) {
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try { this.__jfCart = CART_MUTATION.test(url || ''); } catch (e) {}
      return _open.apply(this, arguments);
    };
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__jfCart) {
        try { this.addEventListener('load', function () { schedule(); }); } catch (e) {}
      }
      return _send.apply(this, arguments);
    };
  }

  // theme event backup
  document.addEventListener('ajaxProduct:added', schedule);

  // capture an existing cart for identified visitors (once per distinct state)
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule);
})();
